
<template>
  <div class="push-noti-main">
    <CRow>
      <CCol sm="12">
        <CCard>
          <CCardHeader>
            <strong class="cemail-main-head flex fs-16 fw-500 col-fonts-grey">
              <CIcon class="cemail-icon mr-2" name="cil-bell" size="lg" />
              Push Notifications
            </strong>
            <div class="cright-side-select-wrap flex">
              <!-- <CSwitch
                class="mr-4"
                :key="key"
                :color="colors"
                v-bind="modes"
                checked
                :value="color"
                v-for="(color, key) in colors"
              /> -->
              <!-- <CSelect
                :options="[
                  'Waste Push Notifications',
                  'Waste Push Notifications',
                  'Option3',
                ]"
              /> -->
            </div>
          </CCardHeader>
          <CCardBody>
            <div
              class="c-accordion"
              data-individual-openable="true"
              data-speed="200"
            >
              <div class="c-accordion__entries">
                <div
                  class="c-accordion__entry is-expanded"
                  aria-expanded="false"
                  role="tablist"
                  v-for="(item, index) in allNotifications"
                  :key="index"
                >
                  <div
                    :id="'c-accordion__entry-title-' + parseInt(index + 1)"
                    class="c-accordion__entry-title"
                    aria-selected="false"
                    :aria-controls="'c-accordion__entry-body-'+ parseInt(index + 1)"
                    role="tab"
                  >
                    <!-- <CSwitch
                      class="ml-3"
                      :key="key"
                      :color="colors"
                      v-bind="modes"
                      checked
                      :value="color"
                      v-for="(color, key) in colors"
                    /> -->
                    <div v-if="item.Status == true">
                      <CSwitch
                        class="ml-3"
                        :key="key"
                        :color="colors"
                        v-bind="modes"
                        checked
                        :value="color"
                        v-for="(color, key) in colors"
                        @change.native="
                          enableDisableNotificationTemplate(
                            $event,
                            item.PushNotificationTemplateId,
                            item.ModuleId
                          )
                        "
                      />
                    </div>
                    <div v-else>
                      <CSwitch
                        class="ml-3"
                        :key="key"
                        :color="colors"
                        v-bind="modes"
                        unchecked
                        :value="color"
                        v-for="(color, key) in colors"
                        @change.native="
                          enableDisableNotificationTemplate(
                            $event,
                            item.PushNotificationTemplateId,
                            item.ModuleId
                          )
                        "
                      />
                    </div>
                    <!-- <div v-if="item.Status == true">
                      <CSwitch
                        class="ml-3"
                        :key="key"
                        :color="colors"
                        v-bind="modes"
                        checked
                        :value="color"
                        v-for="(color, key) in colors"
                        @change.native="
                          enableDisableEmailTemplate(
                            $event,
                            item.EmailTemplateId,
                            item.ModuleId
                          )
                        "
                      />
                    </div>
                    <div v-else>
                      <CSwitch
                        class="ml-3"
                        :key="key"
                        :color="colors"
                        v-bind="modes"
                        unchecked
                        :value="color"
                        v-for="(color, key) in colors"
                        @change.native="
                          enableDisableEmailTemplate(
                            $event,
                            item.EmailTemplateId,
                            item.ModuleId
                          )
                        "
                      />
                    </div> -->
                    <a
                      @click="onHideShow(index + 1)"
                      href="#"
                      class="
                        c-accordion__entry-header-link
                        js-accordion__entry-header-link
                      "
                    >
                      {{ item.ModuleName }}
                      <div class="c-accordion__entry-header-icon-wrapper">
                        <svg
                          class="c-accordion__entry-header-icon"
                          xmlns="http://www.w3.org/2000/svg"
                          width="19.999"
                          height="12.979"
                          viewBox="0 0 19.999 12.979"
                        >
                          <path
                            d="M12,14.979l-10-10L4.979,2,12,9.021,19.02,2,22,4.979Z"
                            transform="translate(-2 -2)"
                            fill="#000"
                          ></path>
                        </svg>
                      </div>
                    </a>
                  </div>
                  <div
                    :id="'c-accordion__entry-body-'+ parseInt(index + 1)"
                    class="c-accordion__entry-body"
                    aria-hidden="false"
                    role="tabpanel"
                    :aria-labelledby="'c-accordion__entry-title-'+ parseInt(index + 1)"
                    style="display: none"
                  >
                    <div class="c-accordion__entry-contents p-2 c-wysiwyg">
                      <CRow>
                        <CCol col="12">
                          <span v-html="item.MessageTitle"></span>
                          <!-- <p class="border pb-5 p-2 rounded p-1">
                            {{ item.MessageBody }}
                          </p> -->
                          <CTextarea
                            :id="'pushArea_' + index"
                            rows="15"
                            :value="item.MessageBody"
                          >
                          </CTextarea>
                          <div class="btn-bottom-wrap mb-2 flex">
                            <CButton class="save-btn"
                            @click="UpdateTemplate(index,item)"
                              >Update Notification</CButton
                            >
                            <!-- <CButton class="delete-btn"
                            @click="DeleteTemplate()"
                              >Delete Notification</CButton
                            > -->
                          </div>
                        </CCol>
                      </CRow>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!-- <CPagination
              :activePage.sync="page"
              :pages="3"
              size="lg-5"
              align="left"
            /> -->
          </CCardBody>
        </CCard>
      </CCol>
    </CRow>
    <div class="loader" v-if="isLoading">
      <CSpinner variant="grow" />
    </div>
  </div>
</template>
<script>
import axios from "axios";
export default {
  data() {
    return {
      isLoading: true,
      modes: [{ shape: "pill" }],
      colors: ["primary"],
      page: 2,
      btn_status: "",
      allNotifications: [],
    };
  },
  mounted() {
    this.getAllNotificationsItems();
  },
  methods: {
    //for delete template
    DeleteTemplate(){
      alert("API not available!");
    },
    onHideShow(indexVal) {
      let printicon = document.getElementById(
        "c-accordion__entry-body-" + parseInt(indexVal)
      );
      if (printicon.style.display != "block") {
        printicon.style.display = "block";
      } else {
        printicon.style.display = "none";
      }
    },
    // for update template
    UpdateTemplate(index,item){
      var token = localStorage.getItem("auth");
      var Session_User_Id = JSON.parse(localStorage.getItem("User_Id"));
      var MessageBody = $("#pushArea_"+index).val();
      const self = this;
      var requestInfo = {
        PushNotificationTemplateId: item.PushNotificationTemplateId,
        ModuleId: item.ModuleId,
        Status: item.Status,
        MessageTitle:item.MessageTitle,
        MessageBody:MessageBody,
        Token: token,
        SessionUserId: Session_User_Id,
      };
      var data = JSON.stringify(requestInfo);
      // console.log(data);
      var config = {
        method: "post",
        url: apiURL + "ManagePushNotificationTemplate/UpdatePushNotificationTemplate",
        headers: {
          "Content-Type": "application/json",
        },
        data: data,
      };
      axios(config)
        .then((result) => {
          this.isLoading = false;
          //console.log(config);
          if (result.data.status_code == 200) {
            this.$swal.fire("Updated", result.data.message, "success");
            //$('.formData')[0].reset();
          } else {
            this.$swal.fire({
              icon: "error",
              title: "Oops...",
              text: result.data.message,
            });
          }
        })
        .catch((error) => {
          this.isLoading = false;
          this.$swal.fire({
            icon: "error",
            title: "Oops...",
            text: "Something went wrong!",
          });
        });
    },
    // for enabeld-disabled notifications
    enableDisableNotificationTemplate(event, NotificationTemplateId, ModuleId) {
      this.btn_status = event.target.checked;
      var token = localStorage.getItem("auth");
      var Session_User_Id = JSON.parse(localStorage.getItem("User_Id"));

      const self = this;
      var requestInfo = {
        PushNotificationTemplateId: NotificationTemplateId,
        ModuleId: ModuleId,
        Status: this.btn_status,
        Token: token,
        SessionUserId: Session_User_Id,
      };
      var data = JSON.stringify(requestInfo);
      const config = {
        method: "POST",
        url:
          apiURL +
          "ManagePushNotificationTemplate/EnableDisablePushNotificationTemplate",
        headers: { "Content-Type": "application/json" },
        data: data,
      };
      axios(config)
        .then((result) => {
          if (result.status == 200) {
            this.isLoading = false;
            this.getAllNotificationsItems();
            self.$swal.fire({
              icon: "success",
              title: "Done...",
              text: result.data.message,
            });
          } else {
            this.isLoading = false;
            self.$swal.fire({
              icon: "error",
              title: "Oops...",
              text: result.data.message,
            });
          }
        })
        .catch(function (error) {
          this.isLoading = false;
          self.$swal.fire({
            icon: "error",
            title: "Oops...",
            text: "Something went wrong!",
          });
        });
    },
    // for get all notifications
    getAllNotificationsItems() {
      var token = localStorage.getItem("auth");
      var Session_User_Id = JSON.parse(localStorage.getItem("User_Id"));

      const self = this;
      var requestInfo = {
        Token: token,
        SessionUserId: Session_User_Id,
      };
      var data = JSON.stringify(requestInfo);
      const config = {
        method: "POST",
        url:
          apiURL +
          "ManagePushNotificationTemplate/GetAllPushNotificationTemplates",
        headers: { "Content-Type": "application/json" },
        data: data,
      };
      // console.log(config);
      axios(config)
        .then((result) => {
          // console.log(result);
          if (result.status == 200) {
            this.isLoading = false;
            console.log(result.data.templateDataList);
            self.allNotifications = result.data.templateDataList;
            // console.log(emailItems);
          } else {
            this.isLoading = false;
            self.$swal.fire({
              icon: "error",
              title: "Oops...",
              text: result.data.message,
            });
          }
        })
        .catch(function (error) {
          this.isLoading = false;
          self.$swal.fire({
            icon: "error",
            title: "Oops...",
            text: "Something went wrong!",
          });
        });
    },
  },
};
var MODULE = MODULE || {};

(function ($, MODULE) {
  MODULE.init_accordion = function () {
    // Logic for accordion
    var accordion = (function () {
      var $accordion_elem = $(".c-accordion"),
        $accordion_headerlink = $accordion_elem.find(
          ".js-accordion__entry-header-link"
        ),
        $accordion_item = $accordion_elem.find(".c-accordion__entry");

      var settings = {
        speed: parseInt($accordion_elem.attr("data-speed")) || 400,
        individual_openable:
          $accordion_elem.attr("data-individual-openable") === "true",
      };

      return {
        init: function () {
          $accordion_headerlink.on("click", function (e) {
            e.preventDefault();
            accordion.toggle($(this));
          });

          if (
            !settings.individual_openable &&
            $(".c-accordion__entry.is-expanded").length > 1
          ) {
            $(".c-accordion__entry.is-expanded").removeClass("is-expanded");
          }
        },
        toggle: function (self) {
          if (
            !settings.individual_openable &&
            self[0] !=
              self
                .closest(".c-accordion")
                .find(
                  ".c-accordion__entry.is-expanded .c-accordion__entry-header-link"
                )[0]
          ) {
            self
              .closest(".c-accordion")
              .find(".c-accordion__entry")
              .removeClass("is-expanded")
              .find(".c-accordion__entry-body")
              .slideUp();
          }

          self
            .closest(".c-accordion__entry")
            .toggleClass("is-expanded")
            .attr("aria-expanded", function (i, attr) {
              return attr == "true" ? "false" : "true";
            });

          self.parent().attr("aria-selected", function (i, attr) {
            return attr == "true" ? "false" : "true";
          });

          self
            .parent()
            .next()
            .stop()
            .slideToggle(settings.speed)
            .attr("aria-hidden", function (i, attr) {
              return attr == "true" ? "false" : "true";
            });
        },
      };
    })();

    accordion.init();
  };

  /* READY FUNCTION
  ====================== */

  $(function () {
    MODULE.init_accordion();
  });
})(jQuery, MODULE);
</script>